'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './affh.routes';
import uuid from "uuid";

export class AffhComponent {
  /*@ngInject*/
  constructor($http, $scope, $location, $timeout, lookup, mapService, theme, dbFactory, db) {
    // Angular classes
    this.$http = $http;
    this.$location = $location;
    this.$scope = $scope;
    this.$timeout = $timeout;

    //Load services
    this.lookup = lookup;
    this.$scope.mapService = mapService;
    this.theme = theme;
    this.dbFactory = dbFactory;
    this.db = db;

    // Global Variables
    this.$scope.selectedRecords = [];
    this.$scope.removeRecords = [];
    this.$scope.addRecords = [];
    this.$scope.listToggle = true;
    this.$scope.filterLength = 0;
    this.$scope.actionsLength = 0;
    this.$scope.filterParcels = [];
    this.$scope.selectedParcels = [];
    this.$scope.myListParcels = [];
    this.$scope.user = {};
    this.$scope.hessTract = {};
    this.$scope.parcelNotes = [];

    this.$scope.addSitesList = [];

    this.$scope.zoomSpinner = false;
    this.$scope.displacementRiskSummary = {};
    this.$scope.hcdSummary = {};
    this.$scope.pocSummary = {};
    this.$scope.rcaaSummary = {};
    this.$scope.recapSummary = {};

    this.$scope.parcelCounts = [{
      "jurisdiction": "Alameda",
      "count_parcel_id": "18914"
    }, {
      "jurisdiction": "Albany",
      "count_parcel_id": "4611"
    }, {
      "jurisdiction": "American Canyon",
      "count_parcel_id": "5174"
    }, {
      "jurisdiction": "Antioch",
      "count_parcel_id": "33214"
    }, {
      "jurisdiction": "Atherton",
      "count_parcel_id": "2588"
    }, {
      "jurisdiction": "Belmont",
      "count_parcel_id": "7841"
    }, {
      "jurisdiction": "Belvedere",
      "count_parcel_id": "1017"
    }, {
      "jurisdiction": "Benicia",
      "count_parcel_id": "10948"
    }, {
      "jurisdiction": "Berkeley",
      "count_parcel_id": "26299"
    }, {
      "jurisdiction": "Brentwood",
      "count_parcel_id": "21467"
    }, {
      "jurisdiction": "Brisbane",
      "count_parcel_id": "1817"
    }, {
      "jurisdiction": "Burlingame",
      "count_parcel_id": "7792"
    }, {
      "jurisdiction": "Calistoga",
      "count_parcel_id": "1687"
    }, {
      "jurisdiction": "Campbell",
      "count_parcel_id": "11991"
    }, {
      "jurisdiction": "Clayton",
      "count_parcel_id": "4317"
    }, {
      "jurisdiction": "Cloverdale",
      "count_parcel_id": "3317"
    }, {
      "jurisdiction": "Colma",
      "count_parcel_id": "483"
    }, {
      "jurisdiction": "Concord",
      "count_parcel_id": "36478"
    }, {
      "jurisdiction": "Corte Madera",
      "count_parcel_id": "3675"
    }, {
      "jurisdiction": "Cotati",
      "count_parcel_id": "2763"
    }, {
      "jurisdiction": "Cupertino",
      "count_parcel_id": "15843"
    }, {
      "jurisdiction": "Daly City",
      "count_parcel_id": "21445"
    }, {
      "jurisdiction": "Danville",
      "count_parcel_id": "16417"
    }, {
      "jurisdiction": "Dixon",
      "count_parcel_id": "6146"
    }, {
      "jurisdiction": "Dublin",
      "count_parcel_id": "15555"
    }, {
      "jurisdiction": "East Palo Alto",
      "count_parcel_id": "4605"
    }, {
      "jurisdiction": "El Cerrito",
      "count_parcel_id": "8751"
    }, {
      "jurisdiction": "Emeryville",
      "count_parcel_id": "1131"
    }, {
      "jurisdiction": "Fairfax",
      "count_parcel_id": "3101"
    }, {
      "jurisdiction": "Fairfield",
      "count_parcel_id": "33415"
    }, {
      "jurisdiction": "Foster City",
      "count_parcel_id": "7317"
    }, {
      "jurisdiction": "Fremont",
      "count_parcel_id": "55989"
    }, {
      "jurisdiction": "Gilroy",
      "count_parcel_id": "14683"
    }, {
      "jurisdiction": "Half Moon Bay",
      "count_parcel_id": "5655"
    }, {
      "jurisdiction": "Hayward",
      "count_parcel_id": "33957"
    }, {
      "jurisdiction": "Healdsburg",
      "count_parcel_id": "4798"
    }, {
      "jurisdiction": "Hercules",
      "count_parcel_id": "8343"
    }, {
      "jurisdiction": "Hillsborough",
      "count_parcel_id": "4162"
    }, {
      "jurisdiction": "Lafayette",
      "count_parcel_id": "9048"
    }, {
      "jurisdiction": "Larkspur",
      "count_parcel_id": "4429"
    }, {
      "jurisdiction": "Livermore",
      "count_parcel_id": "27846"
    }, {
      "jurisdiction": "Los Altos",
      "count_parcel_id": "10686"
    }, {
      "jurisdiction": "Los Altos Hills",
      "count_parcel_id": "3237"
    }, {
      "jurisdiction": "Los Gatos",
      "count_parcel_id": "10652"
    }, {
      "jurisdiction": "Martinez",
      "count_parcel_id": "13345"
    }, {
      "jurisdiction": "Menlo Park",
      "count_parcel_id": "9112"
    }, {
      "jurisdiction": "Millbrae",
      "count_parcel_id": "6125"
    }, {
      "jurisdiction": "Mill Valley",
      "count_parcel_id": "5734"
    }, {
      "jurisdiction": "Milpitas",
      "count_parcel_id": "19240"
    }, {
      "jurisdiction": "Monte Sereno",
      "count_parcel_id": "1252"
    }, {
      "jurisdiction": "Moraga",
      "count_parcel_id": "5981"
    }, {
      "jurisdiction": "Morgan Hill",
      "count_parcel_id": "13095"
    }, {
      "jurisdiction": "Mountain View",
      "count_parcel_id": "18178"
    }, {
      "jurisdiction": "Napa",
      "count_parcel_id": "24154"
    }, {
      "jurisdiction": "Newark",
      "count_parcel_id": "13155"
    }, {
      "jurisdiction": "Novato",
      "count_parcel_id": "18641"
    }, {
      "jurisdiction": "Oakland",
      "count_parcel_id": "98335"
    }, {
      "jurisdiction": "Oakley",
      "count_parcel_id": "13557"
    }, {
      "jurisdiction": "Orinda",
      "count_parcel_id": "7696"
    }, {
      "jurisdiction": "Pacifica",
      "count_parcel_id": "12580"
    }, {
      "jurisdiction": "Palo Alto",
      "count_parcel_id": "19638"
    }, {
      "jurisdiction": "Petaluma",
      "count_parcel_id": "20176"
    }, {
      "jurisdiction": "Piedmont",
      "count_parcel_id": "3999"
    }, {
      "jurisdiction": "Pinole",
      "count_parcel_id": "6536"
    }, {
      "jurisdiction": "Pittsburg",
      "count_parcel_id": "19347"
    }, {
      "jurisdiction": "Pleasant Hill",
      "count_parcel_id": "11420"
    }, {
      "jurisdiction": "Pleasanton",
      "count_parcel_id": "22399"
    }, {
      "jurisdiction": "Portola Valley",
      "count_parcel_id": "1806"
    }, {
      "jurisdiction": "Redwood City",
      "count_parcel_id": "17646"
    }, {
      "jurisdiction": "Richmond",
      "count_parcel_id": "31352"
    }, {
      "jurisdiction": "Rio Vista",
      "count_parcel_id": "5655"
    }, {
      "jurisdiction": "Rohnert Park",
      "count_parcel_id": "11948"
    }, {
      "jurisdiction": "Ross",
      "count_parcel_id": "964"
    }, {
      "jurisdiction": "San Anselmo",
      "count_parcel_id": "4808"
    }, {
      "jurisdiction": "San Bruno",
      "count_parcel_id": "10600"
    }, {
      "jurisdiction": "San Carlos",
      "count_parcel_id": "9817"
    }, {
      "jurisdiction": "San Francisco",
      "count_parcel_id": "154722"
    }, {
      "jurisdiction": "San Jose",
      "count_parcel_id": "227202"
    }, {
      "jurisdiction": "San Leandro",
      "count_parcel_id": "22977"
    }, {
      "jurisdiction": "San Mateo",
      "count_parcel_id": "22381"
    }, {
      "jurisdiction": "San Pablo",
      "count_parcel_id": "6702"
    }, {
      "jurisdiction": "San Rafael",
      "count_parcel_id": "17836"
    }, {
      "jurisdiction": "San Ramon",
      "count_parcel_id": "24198"
    }, {
      "jurisdiction": "Santa Clara",
      "count_parcel_id": "27972"
    }, {
      "jurisdiction": "Santa Rosa",
      "count_parcel_id": "55120"
    }, {
      "jurisdiction": "Saratoga",
      "count_parcel_id": "11099"
    }, {
      "jurisdiction": "Sausalito",
      "count_parcel_id": "3399"
    }, {
      "jurisdiction": "Sebastopol",
      "count_parcel_id": "2923"
    }, {
      "jurisdiction": "Sonoma",
      "count_parcel_id": "4628"
    }, {
      "jurisdiction": "South San Francisco",
      "count_parcel_id": "15867"
    }, {
      "jurisdiction": "St Helena",
      "count_parcel_id": "2308"
    }, {
      "jurisdiction": "Suisun City",
      "count_parcel_id": "8661"
    }, {
      "jurisdiction": "Sunnyvale",
      "count_parcel_id": "31732"
    }, {
      "jurisdiction": "Tiburon",
      "count_parcel_id": "3681"
    }, {
      "jurisdiction": "UNCLASSIFIED",
      "count_parcel_id": "68"
    }, {
      "jurisdiction": "Unincorporated Alameda",
      "count_parcel_id": "41933"
    }, {
      "jurisdiction": "Unincorporated Contra Costa",
      "count_parcel_id": "61796"
    }, {
      "jurisdiction": "Unincorporated Marin",
      "count_parcel_id": "28859"
    }, {
      "jurisdiction": "Unincorporated Napa",
      "count_parcel_id": "15411"
    }, {
      "jurisdiction": "Unincorporated San Mateo",
      "count_parcel_id": "24032"
    }, {
      "jurisdiction": "Unincorporated Santa Clara",
      "count_parcel_id": "27278"
    }, {
      "jurisdiction": "Unincorporated Solano",
      "count_parcel_id": "10454"
    }, {
      "jurisdiction": "Unincorporated Sonoma",
      "count_parcel_id": "70531"
    }, {
      "jurisdiction": "Union City",
      "count_parcel_id": "16260"
    }, {
      "jurisdiction": "Vacaville",
      "count_parcel_id": "30041"
    }, {
      "jurisdiction": "Vallejo",
      "count_parcel_id": "38650"
    }, {
      "jurisdiction": "Walnut Creek",
      "count_parcel_id": "22357"
    }, {
      "jurisdiction": "Windsor",
      "count_parcel_id": "8842"
    }, {
      "jurisdiction": "Woodside",
      "count_parcel_id": "2396"
    }, {
      "jurisdiction": "Yountville",
      "count_parcel_id": "848"
    }];

    this.$scope.displacementRiskCategories = [{
      "displacement_risk": "Advanced Gentrification"
    }, {
      "displacement_risk": "At Risk of Becoming Exclusive"
    }, {
      "displacement_risk": "At Risk of Gentrification"
    }, {
      "displacement_risk": "Becoming Exclusive"
    }, {
      "displacement_risk": "Early/Ongoing Gentrification"
    }, {
      "displacement_risk": "High Student Population"
    }, {
      "displacement_risk": "Low-Income/Susceptible to Displacement"
    }, {
      "displacement_risk": "Ongoing Displacement"
    }, {
      "displacement_risk": "Stable/Advanced Exclusive"
    }, {
      "displacement_risk": "Stable Moderate/Mixed Income"
    }, {
      "displacement_risk": "Unavailable or Unreliable Data"
    }];

    this.$scope.hcdCategories = [{
      "hcd_tcac_resource_level_ua": "Highest Resource"
    }, {
      "hcd_tcac_resource_level_ua": "High Resource"
    }, {
      "hcd_tcac_resource_level_ua": "Low Resource"
    }, {
      "hcd_tcac_resource_level_ua": "Moderate Resource"
    }];

    //Re-add data layers when basemap is switched
    this.$scope.addDataLayer = function($http) {
      // console.log($scope);
      //Function to manage toggling legend map layers [Map Service]
      this.mapService.updateHessToggles(this);
  
      this.map.addSource("parcelsSource", {
        type: "vector",
        url: "mapbox://mtc-basis.5t29n8mv", //Parcel Atlas (updated September 20, 2021)
  
      });
      //Add jurisdiction boundary source
      this.map.addSource("jurisdictionBoundarySource", {
        type: "geojson",
        data: placesGeoJSON,
      });
  
      if (this.array3) {
        this.map.addLayer({
          id: "parcels",
          type: "fill",
          source: "parcelsSource",
          "source-layer": "pa_v24d",
          paint: {
            "fill-outline-color": "black",
            "fill-color": "white",
            "fill-opacity": 0.4,
          },
          filter: this.array3,
        });
      } else {
        this.map.addLayer({
          id: "parcels",
          type: "fill",
          source: "parcelsSource",
          "source-layer": "pa_v24d",
          paint: {
            "fill-outline-color": "black",
            "fill-color": "white",
            "fill-opacity": 0.4,
          },
          filter: ["in", "jurisdiction", this.city],
        });
      }

      if (this.array3List) {
        this.map.addLayer({
          id: "ListLayer",
          type: "fill",
          source: "parcelsSource",
          "source-layer": "pa_v24d",
          layout: this.listVisible,
          paint: {
            "fill-outline-color": "#824086",
            "fill-color": "#824086",
            "fill-opacity": 0.7,
          },
          filter: this.array3List,
        });
      }
      else {
        this.map.addLayer({
          id: "ListLayer",
          type: "fill",
          source: "parcelsSource",
          "source-layer": "pa_v24d",
          layout: this.listVisible,
          paint: {
            "fill-outline-color": "#824086",
            "fill-color": "#824086",
            "fill-opacity": 0.7,
          },
          filter: this.map.ListFilter,
        });
      }
  
      
  
      //Jurisdiction Layer
  
      if (!this.map.getLayer("jurisdiction-boundary")) {
        this.map.addLayer({
          id: "jurisdiction-boundary",
          type: "line",
          source: "jurisdictionBoundarySource",
          paint: {
            "line-color": "black",
            "line-width": 2,
          },
          filter: ["in", "NAME", ""],
        });
      }
  
      console.log(map.selectedFilter);
      if (!this.map.selectedFilter) {
        this.map.selectedFilter = ["in", "parcel_id", ""];
      }
      //Selected Parcels
      this.map.addLayer({
        id: "parcels-highlighted",
        type: "fill",
        source: "parcelsSource",
        "source-layer": "pa_v24d",
        paint: {
          "fill-outline-color": "darkgray",
          "fill-color": "#00fffa",
          "fill-opacity": 0.75,
        },
        filter: this.map.selectedFilter,
      }); // Place polygon under these labels.
  
      if (this.map.layerName) {
        var toggleStatus = this.map.layerName + "Toggle";
        for (let index = 0; index < this.mapLayers.length; index++) {
          const element = this.mapLayers[index];
          if (element.name === this.map.layerName) {
            if (this.map.getSource(element.source)) {
              visibility = this.map.getLayoutProperty(element.name, "visibility");
              // toggle layer visibility by changing the layout object's visibility property
              if (visibility === "visible") {
                this.map.setLayoutProperty(element.name, "visibility", "none");
                this.visibleLayer = element.name;
                this.className = "";
              } else if (toggleStatus == false) {
                this.map.setLayoutProperty(element.name, "visibility", "none");
                this.visibleLayer = element.name;
                this.className = "";
              } else {
                this.className = "active";
                this.map.setLayoutProperty(element.name, "visibility", "visible");
              }
              this.loadingDiv = false;
            } else {
              // console.log(element);
              $http
                .get(element.url)
                .then((response) => {
                  console.log(response);
                  var layerData = response.data;
                  console.log(layerData);
                  var paint = {};
                  var type;
                  var layerName;
                  var legend;
    
                  //Style mapbox layers
                  if (element.type === 'mapbox') {
                    this.map.addSource(element.source, {
                      type: layerData.sources.composite.type,
                      url: layerData.sources.composite.url, //Parcel Atlas (updated September 15 2021)
                    });
    
                    // Check if a filter exists on mapbox and/or add it to the layer
                    if (layerData.layers[0].filter) {
                      console.log(layerData.layers[0].filter);
                      this.map.addLayer({
                        id: element.name,
                        type: layerData.layers[0].type,
                        source: element.source,
                        "source-layer": layerData.layers[0]["source-layer"],
                        paint: layerData.layers[0].paint,
                        filter: layerData.layers[0].filter,
                      },'ListLayer');
                    } else {
                      this.map.addLayer({
                        id: element.name,
                        type: layerData.layers[0].type,
                        source: element.source,
                        "source-layer": layerData.layers[0]["source-layer"],
                        paint: layerData.layers[0].paint
                      },'ListLayer');
                    }
                  }
    
                  //  Style socrata tract layers 
                  else if (element.type === 'socrata') {
    
                    //Set the paint type based on the style from map.service.js
                    if (element.style === 'circle') {
                      type = 'circle';
                    } else {
                      type = 'fill'
                    }
    
                    //For numerical styles, make sure values are numbers and not strings
                    if (element.style !== 'circle') {
                      console.log(element.property);
                      console.log(layerData);
                      if (element.style === 'numerical') {
                        layerData.forEach(data => {
                          data[element.property] = parseFloat(data[element.property]);
                        });
                      }
    
                      if (element.name === 'raceEthnicityLayer') {
                        //Retrieve Block Geometry Layer
                        $http.get('https://data.bayareametro.gov/resource/f86g-vq5u.geojson?$limit=5000000')
                          .then(response => {
                            console.log(response.data);
    
                            var blockGeo = response.data;
    
                            // Numerical or Categorical styles -- Join layerData attributes to tract geometry 
                            if (element.style === 'numerical') {
                              blockGeo.features.forEach(block_element => {
                                var blockId = _.filter(layerData, {
                                  'blkgp_geoid': block_element.properties.geoid
                                })
                                if (blockId[0]) {
                                  block_element.properties[element.property] = parseFloat(blockId[0][element.property]);
                                }
                              });
                            } else if (element.style === 'categorical') {
                              blockGeo.features.forEach(block_element => {
                                var blockId = _.filter(layerData, {
                                  'blkgp_geoid': block_element.properties.geoid
                                })
                                if (blockId[0]) {
                                  block_element.properties[element.property] = blockId[0][element.property];
                                }
                              });
    
    
                            }
    
                            console.log(element.source);
                            console.log(blockGeo)
    
                            //  Add source and layer to the map 
                            this.map.addSource(element.source, {
                              type: 'geojson',
                              data: blockGeo
                            });
    
                            this.map.addLayer({
                              id: element.name,
                              type: type,
                              source: element.source,
                              'paint': element.paint
                            },'ListLayer');
    
                            //Add dynamic legend
                            console.log("Legend: ", element.paint);
                            legend = element.paint['fill-color'].stops;
                            console.log(element.paint);
                            legend.forEach(legend => {
                              if(this.layerLegend.length === 0){
                                if (element.style === 'numerical') {
                                  this.layerLegend.push({
                                    "type": 'numerical',
                                    "value": legend[0] + "%",
                                    "color": legend[1]
                                  })
                                } else {
                                  this.layerLegend.push({
                                    "type": 'categorical',
                                    "value": legend[0],
                                    "color": legend[1]
                                  })
                                }
                              }
    
                            });
                            console.log(this.layerLegend);
    
                            this.map.setLayoutProperty(element.name, "visibility", "visible");
    
                          })
                      } else if(layerName === 'hcdaffhtcacLayer'){
                        console.log(layerData);
                        this.map.addSource(element.source, {
                          type: 'geojson',
                          data: layerData
                        });
    
                        this.map.addLayer({
                          id: element.name,
                          type: type,
                          source: element.source,
                          'paint': element.paint
                        },'ListLayer');
                        this.map.setLayoutProperty(element.name, "visibility", "visible");
                        console.log(this.hcdaffhtcacLayerToggle);
    
                        legend = element.paint['fill-color'].stops;
                        console.log(element.paint);
                        legend.forEach(legend => {
                           if(this.layerLegend.length === 0){
                            this.layerLegend.push({
                              "type": 'categorical',
                              "value": legend[0],
                              "color": legend[1]
                            })
                           }
                        })
                        
    
                      } else {
                        // Retrieve Tract Geometry layer 
                        $http.get('https://data.bayareametro.gov/resource/j4u9-t2hp.geojson?$limit=20000')
                          .then(response => {
                            console.log(response.data);
    
                            var tractGeo = response.data;
    
                            // Numerical or Categorical styles -- Join layerData attributes to tract geometry 
                            if (element.style === 'numerical') {
                              tractGeo.features.forEach(tract_element => {
                                var tractId = _.filter(layerData, {
                                  'tract_geoid': tract_element.properties.geoid
                                })
                                if (tractId[0]) {
                                  // console.log(tractId[0]);
                                  tract_element.properties[element.property] = parseFloat(tractId[0][element.property]);
                                }
                              });
                            } else if (element.style === 'categorical') {
                              console.log(layerData);
    
                              tractGeo.features.forEach(tract_element => {
                                var tractId = _.filter(layerData, {
                                  'tract_geoid': tract_element.properties.geoid
                                })
                                // console.log(tractId);
                                if (tractId[0]) {
                                  tract_element.properties[element.property] = tractId[0][element.property];
                                }
                              });
    
    
                            } else if(element.style === 'single'){
                              console.log("single");
                                tractGeo.features = _.filter(tractGeo.features,function(geo){
                                  // console.log(geo);
                               var test = _.filter(layerData,{'tract_geoid': geo.properties.geoid});
                               if(test[0]){
                                 return geo;
                               }
                            
                              })
                              // tractGeo.features = features;
                            }
                            console.log(element.name);
                            console.log(element.source);
                            console.log(tractGeo)
    
                            //  Add source and layer to the map 
                            this.map.addSource(element.source, {
                              type: 'geojson',
                              data: tractGeo
                            });
    
                            this.map.addLayer({
                              id: element.name,
                              type: type,
                              source: element.source,
                              'paint': element.paint 
                            },'ListLayer');
    
                            //Add dynamic legend
                            console.log("Legend: ", element.paint);
                            if(element.paint['fill-color'].stops){
                            legend = element.paint['fill-color'].stops;
                            console.log(element.paint);
                            legend.forEach(legend => {
                            if(this.layerLegend.length === 0){
                              if (element.style === 'numerical') {
                                if (layerName === "householdIncomeLayer") {
                                  this.layerLegend.push({
                                    "type": 'numerical',
                                    "value": "$" + legend[0],
                                    "color": legend[1]
                                  })
                                } else {
                                  this.layerLegend.push({
                                    "type": 'numerical',
                                    "value": legend[0] + "%",
                                    "color": legend[1]
                                  })
                                }
                              } else {
                                this.layerLegend.push({
                                  "type": 'categorical',
                                  "value": legend[0],
                                  "color": legend[1]
                                })
                              }
                            }
    
                            });
                            }
                            console.log(this.layerLegend);
    
                            this.map.setLayoutProperty(element.name, "visibility", "visible");
    
                          })
                      }
    
    
                    }
    
                    // Circle/point styles -- Join layer attributes to tract geometry
                    if (element.style === "circle") {
                      console.log(element.property);
                      console.log(layerData);
                      layerData.features.forEach(data => {
                        data.properties[element.property] = parseFloat(data.properties[element.property]);
                      });
    
                      this.map.addSource(element.source, {
                        type: 'geojson',
                        data: layerData
                      });
                      console.log(element.paint);
    
                      // Add dynamic legend 
                      legend = element.paint;
                      legend['circle-radius'].stops.forEach(circleItem => {
                        this.layerLegend.push({
                          "type": 'circle',
                          "color": legend['circle-color'],
                          "value": circleItem[0] + " units",
                          "size": circleItem[1] + "px"
                        })
                      });
    
                      this.map.addLayer({
                        id: element.name,
                        type: type,
                        source: element.source,
                        'paint': element.paint
                      });
                    }
    
                  }
    
                  // Add default opacity to 50% 
                  if (element.name !== 'sphereofinfluenceLayer' && element.type === 'mapbox') {
                    this.map.setPaintProperty(element.name, "fill-opacity", 0.5);
                  }
    
                  if (element.name === 'sphereofinfluenceLayer') {
                    console.log(element.name);
                    this.map.setFilter(element.name, [
                      "match",
                      [
                        "get",
                        "jurisdiction"
                      ],
                      [
                        this.city
                      ],
                      true,
                      false
                    ]);
                  }
    
                  this.loadingDiv = false;
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          } else {
            if (this.map.getSource(element.source)) {
              this.map.setLayoutProperty(element.name, "visibility", "none");
              this[element.name + "Toggle"] = false;
            }
          }
        }
      }
    }

  }

  $onInit() {


    if (this.$location.search().parcel_id) {
      console.log(this.$location.search());
      this.$scope.dataParcel_id = this.$location.search().parcel_id;
    }

    // Get category layers and colors [Lookup Service]
    this.$scope.hessCategoryLayers = this.lookup.getHessCategoryLayers();

    //Get list of toggle map layers [Map Service]
    this.$scope.mapLayers = this.$scope.mapService.getMapLayers();

    //Load theme functions
    this.theme.initTheme();


    // Activate Multiple Selects 
    // $('#regionalZoneSelect').selectpicker();



    // Get list of regional zoning codes 
    this.$scope.zn_regional_codes = this.lookup.getRegionalCodes();
    // console.log(this.$scope.zn_regional_codes);

    //  Activate the Tooltips
    $('[data-toggle="tooltip"], [rel="tooltip"]').tooltip();


    /**
     * API call to get user Organization info. Resolves promise synchronously from logged in user query, and then queries organization info. Pulled from Sql Server
     * param: Organization_ID (from logged in user)
     */
    if (this.db.getUser().length === 0) {
      this.$http
        .get("/api/users/general")
        .then((response) => {
          console.log(response);
          this.$scope.user = response.data[0];
          this.$scope.role = this.$scope.user.role;
          this.$scope.city = response.data[0].Organization_Name;
          this.db.setUser(response.data[0]);
          console.log(this.$scope.city);
          if (this.$scope.role !== "jurisdiction") {
            this.getJurisdictions();
          }
          //Load Map and Hess Summary with a 2 second delay
          this.loadMap(this.$scope.city);
          // this.getDisplacementRiskSummaries();
          // this.getHCDSummaries();
          // this.getPOCSummaries();
          // this.getRCAASummaries();
          // this.getRECAPSummaries();

        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      this.$scope.user = this.db.getUser();
      this.$scope.role = this.$scope.user.role;
      if (this.$scope.role !== "jurisdiction") {
        this.getJurisdictions();
      }
      console.log("the user service: ", this.db.getUser());
      this.$scope.city = this.$scope.user.Organization_Name;
      //Load Map and Hess Summary with a 2 second delay
      this.loadMap(this.$scope.city);

      // this.getDisplacementRiskSummaries();
      // this.getHCDSummaries();
      // this.getPOCSummaries();
      // this.getRCAASummaries();
      // this.getRECAPSummaries();
    }

 
    

  }



  loadMap(city) {
    console.log('running load map');
    //Create local variables based on global variables
    var $scope = this.$scope;
    var $http = this.$http;
    var $location = this.$location;
    // var city = this.$scope.city;
    var updateInfoBox = this.updateInfoBox;
    var updateHessTract = this.updateHessTract;
    var dbFactory = this.dbFactory;
    this.$scope.toggleMapLayer = this.toggleMapLayer;
    this.$scope.selectedRecords = [];
    var selectedRecords = [];
    var addSitesList = [];
    var listRecords = [];
    var mapService = this.$scope.mapService;

    this.$scope.removeRecords = [];
    var removeRecords = [];

    this.$scope.addRecords = [];
    var addRecords = [];
    var rowSelectedCollection = [];

    // define map
    mapboxgl.accessToken =
      "pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNranVpYWNqeTFtMHEyeXRjdjFnN2lldTUifQ.09JACeDB27_PEaebVWA9rA";
    $scope.map = new mapboxgl.Map({
      container: "map", // container id
      style: "mapbox://styles/mapbox/light-v10", // stylesheet location
      zoom: 9,
      center: [-122.275051, 37.796966], //Set center based on geojson feature
    });

    $scope.map.addControl(
      new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,

        // limit results to US
        countries: "us",

        // further limit results to the geographic bounds representing the region of
        // California
        // bbox: [139.965, -38.03, 155.258, -27.839],

        // apply a client side filter to further limit results to those strictly within
        // the California region
        filter: function (item) {
          // returns true if item contains California region
          return item.context
            .map(function (i) {
              // id is in the form {index}.{id} per https://github.com/mapbox/carmen/blob/master/carmen-geojson.md
              // this example attempts to find the `region` named `California`
              return (
                i.id.split(".").shift() === "region" && i.text === "California"
              );
            })
            .reduce(function (acc, cur) {
              return acc || cur;
            });
        },
        mapboxgl: mapboxgl,
      })
    );

    // Add zoom and rotation controls to the map.
    $scope.map.addControl(new mapboxgl.NavigationControl());

    var loadHessLayers = this.loadHessLayers;
    // var toggleMapLayer = this.toggleMapLayer;
    var zoomToSiteFromParams = this.zoomToSiteFromParams;
    var openSiteEditModalMoreInfo = this.openSiteEditModalMoreInfo;

    $scope.map.on("load", function (map) {
      console.log(this.$scope);
      console.log($scope);
      console.log("scope");
      //    Add Parcels Source
      map.target.addSource("parcelsSource", {
        type: "vector",
        //url: "mapbox://mtc-basis.cd90r7zz", //Parcel Atlas (updated December 9 2020)
        url: "mapbox://mtc-basis.5t29n8mv", //Parcel Atlas (updated September 20 2021) 
      });
      //Add jurisdiction boundary source
      map.target.addSource("jurisdictionBoundarySource", {
        type: "geojson",
        data: placesGeoJSON,
      });

      //Add HCD/TCAC query layer
      map.target.addSource("hcdaffhtcacLayerQuerySource", {
        type: "geojson",
        data: "https://data.bayareametro.gov/resource/vr7h-smni.geojson?$limit=10000&$select=oppcat,geometry",
      });





      map.target.addLayer({
        id: "parcels",
        type: "fill",
        source: "parcelsSource",
        "source-layer": "pa_v24d",
        paint: {
          "fill-outline-color": "black",
          "fill-color": "white",
          "fill-opacity": 0.4,
        },
        filter: ["in", "jurisdiction", $scope.city],
      });




      // Add my sites 
      map.target.addLayer({
        id: "ListLayer",
        type: "fill",
        source: "parcelsSource",
        "source-layer": "pa_v24d",
        paint: {
          "fill-outline-color": "white",
          "fill-color": "#824086",
          "fill-opacity": 0.7,
        },
        filter: ["in", "county", ""],
      });


      map.target.addLayer({
        id: "hcdaffhtcacLayerQuery",
        type: "fill",
        source: "hcdaffhtcacLayerQuerySource",
        paint: {
          "fill-outline-color": "black",
          "fill-color": "white",
          "fill-opacity": 0,
        }
      },'ListLayer');

      //Jurisdiction Layer

      if (!map.target.getLayer("jurisdiction-boundary")) {
        map.target.addLayer({
          id: "jurisdiction-boundary",
          type: "line",
          source: "jurisdictionBoundarySource",
          paint: {
            "line-color": "black",
            "line-width": 2,
          },
          filter: ["in", "NAME", ""],
        });
      }

      //Selected Parcels
      if (!map.target.getLayer("parcels-highlighted")) {
        map.target.addLayer({
          id: "parcels-highlighted",
          type: "fill",
          source: "parcelsSource",
          "source-layer": "pa_v24d",
          paint: {
            "fill-outline-color": "darkgray",
            "fill-color": "#00fffa",
            "fill-opacity": 0.75,
          },
          filter: ["in", "parcel_id", ""],
        }); // Place polygon under these labels.
      }


      // Map Layer Toggle
      var layerList = document.getElementById("menu");
      var inputs = layerList.getElementsByTagName("input");
      // console.log(inputs);

      //Add data layers once style has loaded
      map.target.on("style.load", function () {
        // Triggered when `setStyle` is called.
        // add data layers to map
        $scope.addDataLayer($http);
      });

      function switchLayer(layer) {
        // console.log(map);
        var layerId = layer.target.id;
        map.target.setStyle("mapbox://styles/mapbox/" + layerId);
      }

      for (var i = 0; i < inputs.length; i++) {
        inputs[i].onclick = switchLayer;
      }
      //End map layer toggle

      //Zoom map to jurisdiction currently logged in
      var zoomToFeature = _.filter(placesGeoJSON.features, function (item) {
        return item.properties.NAME === city;
      });

      var bbox = turf.extent(zoomToFeature[0].geometry);
      map.target.fitBounds(bbox, {
        padding: -150,
      });

      // When a click event occurs on a feature in the states layer, open a popup at the
      // location of the click, with description HTML from its properties.
      map.target.on("click", "parcels", function (e) {
        // $('.mapboxgl-popup').remove();
        var coordinates = e.lngLat;
        console.log("325: coordinates", coordinates);

        // Ensure that if the map is zoomed out such that multiple
        // copies of the feature are visible, the popup appears
        // over the copy being pointed to.
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }

        // set bbox as 5px reactangle area around clicked point
        var bbox = [
          [e.point.x - 5, e.point.y - 5],
          [e.point.x + 5, e.point.y + 5],
        ];
        var features = map.target.queryRenderedFeatures(bbox, {
          layers: ["parcels"],
        });
        // console.log(features);

        selectedRecords = $scope.selectedRecords;
        removeRecords = $scope.removeRecords;
        addRecords = $scope.addRecords;
        addSitesList = $scope.addSitesList;
        listRecords = $scope.listRecords;
        rowSelectedCollection = $scope.rowSelectedCollection;
        // updateInfoBox(e.features[0].properties.parcel_id, $http, $scope, dbFactory, coordinates, openSiteEditModalMoreInfo);

        var filter = features.reduce(
          function (memo, feature) {
            memo.push(feature.properties.parcel_id);

            var checkParcelId = feature.properties.parcel_id;
            var checkIndex = selectedRecords.indexOf(checkParcelId);
            var checkRemoveIndex = removeRecords.indexOf(checkParcelId);
            var checkAddIndex = addRecords.indexOf(checkParcelId);
            var checkListIndex = listRecords.indexOf(checkParcelId);

            if (checkIndex > -1) {
              // Remove record from selected map layer 
              selectedRecords.splice(checkIndex, 1);
              //Remove from variable being used for Redshift functions
              addSitesList = addSitesList.filter(data => data.parcel_id != checkParcelId);
              // Remove record from selected tab table 
              _.remove(rowSelectedCollection, {
                parcel_id: feature.properties.parcel_id,
              });
            } else {
              selectedRecords.push(feature.properties.parcel_id);

            }

            // if (checkAddIndex > -1) {
            //   addRecords.splice(checkAddIndex, 1);
            // } else if (checkAddIndex === -1 && checkListIndex === -1) {
            //   addRecords.push(feature.properties.parcel_id);
            // }

            if (checkRemoveIndex > -1) {
              $scope.removeRecords.splice(checkRemoveIndex, 1);
            } else {
              $scope.listRecords.forEach((element) => {
                if (element === checkParcelId) {
                  $scope.removeRecords.push(checkParcelId);
                }
              });
            }
            // console.log($scope.removeRecords);

            return memo;
          },
          ["in", "parcel_id"]
        );
        $scope.selectedRecords = selectedRecords;
        $scope.addSitesList = addSitesList;
        //Update Update button with selected records count

        var array1 = ["in", "parcel_id"];
        var array2 = $scope.selectedRecords;

        var array3 = array1.concat(array2);

        // Set the filter to populate features into the layer.
        map.target.setFilter("parcels-highlighted", array3);
        map.target.selectedFilter = array3;

        $scope.selectedParcelId = e.features[0].properties.parcel_id;
        updateInfoBox(e.features[0].properties.parcel_id, $http, $scope, dbFactory, openSiteEditModalMoreInfo);
      });

      //Add click events to hess layers
      $scope.hessCategoryLayers.forEach((element) => {
        map.target.on("click", element.name + "Layer", function (e) {
          // $('.mapboxgl-popup').remove();
          var coordinates = e.lngLat;
          // Ensure that if the map is zoomed out such that multiple
          // copies of the feature are visible, the popup appears
          // over the copy being pointed to.
          // while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          // coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
          // }
          updateInfoBox(e.features[0].properties.parcel_id, $http, $scope, dbFactory, coordinates, openSiteEditModalMoreInfo);


        });
      });

      map.target.on("click", "ListLayer", function (e) {
        // $('.mapboxgl-popup').remove();
        updateInfoBox(e.features[0].properties.parcel_id, $http, $scope, dbFactory, openSiteEditModalMoreInfo);
      });

      map.target.on("click", "hcdaffhtcacLayerQuery", function (e) {
        // $('.mapboxgl-popup').remove();
        console.log(e.features);
        updateHessTract(e.features[0].properties.oppcat,$scope);
      });

      // Change the cursor to a pointer when the mouse is over the parcels layer.
      map.target.on("mouseenter", "parcels", function () {
        map.target.getCanvas().style.cursor = "pointer";
      });

      // Change it back to a pointer when it leaves.
      map.target.on("mouseleave", "parcels", function () {
        map.target.getCanvas().style.cursor = "";
      });

      // Change the cursor to a pointer when the mouse is over the list layer.
      map.target.on("mouseenter", "ListLayer", function () {
        map.target.getCanvas().style.cursor = "pointer";
      });

      // Change it back to a pointer when it leaves.
      map.target.on("mouseleave", "ListLayer", function () {
        map.target.getCanvas().style.cursor = "";
      });

      //Update cursor to pointer on mouseover for hess layers
      $scope.hessCategoryLayers.forEach((element) => {
        // Change the cursor to a pointer when the mouse is over the states layer.
        map.target.on("mouseenter", element.name + "Layer", function () {
          map.target.getCanvas().style.cursor = "pointer";
        });

        // Change it back to a pointer when it leaves.
        map.target.on("mouseleave", element.name + "Layer", function () {
          map.target.getCanvas().style.cursor = "";
        });
      });

      // Set global map variable based on local map variable settings
      $scope.map = map.target;

      //Load Hess Layers
      loadHessLayers($http, $scope);

      // Zoom to site if parameters present for parcel id
      zoomToSiteFromParams($scope.dataParcel_id, $scope, $http, $location);
    });



    // Get my list of parcels 
    this.getMyList();

    //Load zoning, gp and existing use codes
    // this.loadAllCodes();

    // Load Enviro Summary 
    // this.loadHessEnviroSummary();

    //Load Planning Summary
    // this.loadHessPlanningSummary();
  }



  updateInfoBox(parcel_id, $http, $scope, dbFactory, coordinates, openSiteEditModalMoreInfo) {
    // console.log("line 863: ", coordinates);


    var basicInfoPopup;
    // console.log(openSiteEditModalMoreInfo);
    $("#layersTabNav").removeClass("active");
    $("#myListTabNav").removeClass("active");
    $("#filtersTabNav").removeClass("active");
    $("#adminTabNav").removeClass("active");
    $("#summariesTabNav").removeClass("active");

    $("#selectedTabNav").addClass("active");

    $("#layersTabPanel").removeClass("active");
    $("#myListTabPanel").removeClass("active");
    $("#filtersTabPanel").removeClass("active");
    $("#adminTabPanel").removeClass("active");
    $("#summariesTabPanel").removeClass("active");


    $("#selectedTabPanel").addClass("active");
    // console.log(coordinates);


    dbFactory
      .getParcelDetail(parcel_id)
      .then((response) => {
        console.log("dbFactory: ", response.data[0]);
        var feature = response.data[0];
        $scope.feature = response.data[0];
        var addRecordToSelected = alasql('select * from ? where parcel_id = "' + $scope.feature.parcel_id + '"', [$scope.selectedParcels]);

        // If record has not already been added to Selection, add it 
        if (addRecordToSelected.length === 0) {
          $scope.selectedParcels.push(response.data[0]);
          $scope.rowSelectedCollection = _.uniqBy($scope.selectedParcels, "parcel_id");
        }

        // console.log($scope.rowSelectedCollection);
        var parcel_id = feature.parcel_id;

        // console.log("895: coordinates ", coordinates);
        console.log(Array.isArray(coordinates));
        // if(basicInfoPopup){
        //   basicInfoPopup.remove()
        // } else {
        //   basicInfoPopup = new mapboxgl.Popup()
        //   .setLngLat(coordinates)
        //   .setHTML('<h5>Basic Information</h5><table class="table"><tr><td>Jurisdiction:</td><td>' + feature.jurisdiction + '</td></tr><tr><td>APN:</td><td>' + feature.apn + '</td></tr><tr><td>Address:</td><td>' + feature.address + '</td></tr><tr><td>5 Digit Zip Code:</td><td>' + feature.zip_code + '</td></tr><tr><td><button id="moreInfoBtn" class="btn btn-default disabled">More Info</button></td></tr></table>')
        //   .addTo($scope.map);
        // }

        // setTimeout(function () {
        //   $('#moreInfoBtn').removeClass('btn-default').removeClass('disabled').addClass('btn-primary');
        //   // console.log($('#moreInfoBtn'));
        //   $('#moreInfoBtn').on('click', function () {
        //     openSiteEditModalMoreInfo(parcel_id, $http, $scope, dbFactory);
        //   })
        // }, 300);

      })
      .catch((err) => {
        console.log(err);
      });
  }

  updateHessTract(oppcat,$scope){
    $scope.hessTract.hcd_tcac_resource_level = oppcat;
    console.log($scope.hessTract);
  }

  loadAllCodes() {
    this.$scope.zn_codes = [];
    this.$scope.gp_codes = [];
    //Get list of zoning codes. If list doesn't exist in lookup service, request from server
    // if (this.lookup.getZoningCodes().length > 0) {
    //   this.$scope.zn_codes = this.lookup.getZoningCodes();
    // } else {
    this.$http
      .get("/api/data/parcels/zncodes/" + this.$scope.city)
      .then((response) => {
        console.log("zoning codes: ", response.data);
        this.$scope.zn_codes = response.data;
        //Set zoning codes in lookup service
        this.lookup.setZoningCodes(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
    // }

    //Get list of GP codes. If list doesn't exist in lookup service, request from server
    // if (this.lookup.getGPCodes().length > 0) {
    //   this.$scope.gp_codes = this.lookup.getGPCodes();
    // } else {
    this.$http
      .get("/api/data/parcels/gpcodes/" + this.$scope.city)
      .then((response) => {
        this.$scope.gp_codes = response.data;
        console.log('gp_codes: ', this.$scope.gp_codes);
        //Set GP codes in lookup service
        this.lookup.setGPCodes(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
    // }

    //Get list of use codes
    if (this.lookup.getUseCodes().length > 0) {
      this.$scope.use_codes = this.lookup.getUseCodes();
    } else {
      this.$http
        .get("/api/data/hess/parcel/uses/" + this.$scope.city)
        .then((response) => {
          this.$scope.use_codes = response.data;
          this.lookup.setUseCodes(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  loadHessLayers($http, $scope) {

    $http
      .get("/api/data/hess/layers/list/ids/" + $scope.city)
      .then((response) => {
        // console.log("List: ", response.data);
        $scope.listRecords = _.map(response.data, "parcel_id");
        // $scope.listRecords = [];
        var listRecords = $scope.listRecords;
        // console.log(listRecords);

        var array1 = ["in", "parcel_id"];
        var array3 = array1.concat(listRecords);

        // Set the filter to populate features into the layer.
        $scope.map.setFilter("ListLayer", array3);
        $scope.map.ListFilter = array3;
      })
      .catch((err) => {
        console.log(err);
      });
  }



  // Environmental Constraints Summary
  loadHessEnviroSummary() {
    if (this.lookup.getHessEnviroSummary().hasOwnProperty('in_cpad')) {
      this.$scope.hessEnviroSummary = this.lookup.getHessEnviroSummary();
    } else {
      this.$scope.hessEnviroSummary = {
        in_cpad: 0,
        in_floodplain: 0,
        in_landslide: 0,
        in_liquefact: 0,
        in_riparian: 0,
        in_seismic: 0,
        in_habitat: 0,
        in_slr36: 0,
        in_slr77: 0,
        // in_liquefaction: 0,
        // The following value i snot currently a boolean
        fire_haz_class: ''
      };

      for (const key in this.$scope.hessEnviroSummary) {
        // console.log(key);
        this.$http
          .get("/api/data/hess/enviro/" + key)
          .then(response => {
            if (response.data[0]) {
              var key_count = key + '_count';
              this.$scope.hessEnviroSummary[key] = response.data[0][key_count];
              // console.log(this.$scope.hessEnviroSummary);
            }

          })
          .catch(err => {
            console.log(err);
          })
      }

      this.lookup.setHessEnviroSummary(this.$scope.hessEnviroSummary);
    }

  }

  // Planning Considerations Summary
  loadHessPlanningSummary() {
    if (this.lookup.getHessPlanningSummary().hasOwnProperty('in_pda')) {
      this.$scope.hessPlanningSummary = this.lookup.getHessPlanningSummary();
    } else {
      this.$scope.hessPlanningSummary = {
        in_pda: 0,
        in_tpa: 0,
        in_ppa: 0,
        in_urban_area: 0,
        in_hra: 0,
        in_gg: 0
      };

      for (const key in this.$scope.hessPlanningSummary) {
        // console.log(key);
        this.$http
          .get("/api/data/hess/planning/" + key)
          .then(response => {
            // console.log(response.data[0]);
            if (response.data[0]) {
              var key_count = key + '_count';
              this.$scope.hessPlanningSummary[key] = response.data[0][key_count];
              // console.log(this.$scope.hessPlanningSummary);
            }

          })
          .catch(err => {
            console.log(err);
          })
      }

      this.lookup.setHessPlanningSummary(this.$scope.hessPlanningSummary);
    }
  }


  //Start clear selected function
  clearSelected() {
    // $('.mapboxgl-popup').remove();
    this.$scope.selectedRecords = [];
    this.$scope.removeRecords = [];
    this.$scope.addRecords = [];
    this.$scope.selectedParcels = [];
    this.$scope.rowSelectedCollection = [];
    var array1 = ["in", "parcel_id", ""];
    this.$scope.parcelSummary = null;

    this.$scope.map.selectedFilter = ["in", "parcel_id", ""];
    this.$scope.map.setFilter("parcels-highlighted", array1);

  }
  //End clear selected function

  // Start add to list function
  addSitesToList(parcel_id) {
    this.$scope.addToSitesSpinner = true;

    if (parcel_id) {
      console.log("there was a parcel id");
      this.$scope.addRecords.push(parcel_id);
    } else if (this.$scope.selectedRecords.length > 0) {
      this.$scope.selectedRecords.forEach(element => {
        console.log(element);
        console.log(typeof this.$scope.addRecords[element]);
        if (typeof this.$scope.addRecords[element] === 'undefined') {
          this.$scope.addRecords.push(element);
        }
      });
    }
    console.log(this.$scope.addRecords);
    this.$http
      .post("/api/data/hess/parcel/list/add", this.$scope.addRecords)
      .then((response) => {
        this.$scope.addRecords.forEach((element) => {
          this.$scope.listRecords.push(element);
          console.log(this.$scope.listRecords);

          var array1 = ["in", "parcel_id"];
          var array3 = array1.concat(this.$scope.listRecords);

          // Set the filter to populate features into the layer.
          this.$scope.map.setFilter("ListLayer", array3);
          this.clearSelected();

        });

        this.$scope.selectedRecords = [];
        this.$scope.addRecords = [];
        // this.$scope.listRecords = [];
        this.$scope.addToSitesSpinner = false;
        this.getMyList();
      })
      .catch((err) => {
        console.log(err);
        this.$scope.addToSitesSpinner = false;
      });
  }

  // Start remove from list function
  removeSitesFromList(parcel_id) {
    this.$scope.removeSitesSpinner = false;
    var checkIndex;
    this.$scope.removeRecords = [];

    //If parcel is being deleted from my list tab, remove it both from local array and socrata table
    if (this.$scope.myListParcels.length > 0 && parcel_id) {
      this.$scope.removeRecords.push(parcel_id);
      _.remove(this.$scope.myListParcel, {
        parcel_id: parcel_id,
      });

      _.remove(this.$scope.rowListCollection, {
        parcel_id: parcel_id,
      });
    }

    this.$http
      .post("/api/data/hess/parcel/list/remove", this.$scope.removeRecords)
      .then((response) => {
        var checkIndex;
        // console.log("the remove records: ", this.$scope.removeRecords);

        this.$scope.removeRecords.forEach(element => {
          checkIndex = this.$scope.listRecords.indexOf(element);
          // console.log(checkIndex);
          this.$scope.listRecords.splice(checkIndex, 1);
          // console.log("the list of records: ", this.$scope.listRecords);

          var array1 = ["in", "parcel_id"];
          var array3 = array1.concat(this.$scope.listRecords);
          // console.log(array3);

          // Set the filter to populate features into the layer.
          this.$scope.map.setFilter("ListLayer", array3);
          this.clearSelected();
        });

        this.$scope.selectedRecords = [];
        this.$scope.removeRecords = [];
        this.$scope.removeSitesSpinner = false;
      })
      .catch((err) => {
        console.log(err);
        this.$scope.removeSitesSpinner = false;
      });
  }
  // End remove from list function

  // Start update parcel function
  updateSiteData() {
    var data = this.$scope.hessParcel;


    //Add use code description based on use code
    if (data.existing_use_code) {
      data.existing_use_description = _.filter(this.$scope.use_codes, {
        existing_use_code: data.existing_use_code,
      })[0].existing_use_description;
    }
    // console.log("use codes: ", data.existing_use_code);
    // console.log(data.existing_use_description);

    // console.log(data);

    //test hess category calculation
    this.$http
      .post("/api/data/hess/update", data)
      .then((response) => {
        // console.log("283. ", response);
        var hess_category = response.data.hess_category;

        //Find parcel id being updated in the hess layers, and update layers accordingly
        var posRed = this.$scope.map.RedFilter.indexOf(response.data.parcel_id);
        var posYellow = this.$scope.map.YellowFilter.indexOf(response.data.parcel_id);
        var posGreen = this.$scope.map.GreenFilter.indexOf(response.data.parcel_id);
        var posPink = this.$scope.map.PinkFilter.indexOf(response.data.parcel_id);
        var posOrange = this.$scope.map.OrangeFilter.indexOf(response.data.parcel_id);
        var posBlue = this.$scope.map.BlueFilter.indexOf(response.data.parcel_id);
        var posGray = this.$scope.map.GrayFilter.indexOf(response.data.parcel_id);


        console.log(posRed);
        console.log(posYellow);
        console.log(posGreen);
        console.log(posPink);
        console.log(posBlue);
        console.log(posOrange);
        console.log(posGray);

        // Red 
        if (hess_category === "Environmentally Constrained Sites" && posRed === -1) {
          // console.log('it should be red');
          this.$scope.map.RedFilter.push(response.data.parcel_id);

          if (posYellow > -1) {
            this.$scope.map.YellowFilter.splice(posYellow, 1);
          }
          if (posGreen > -1) {
            this.$scope.map.GreenFilter.splice(posGreen, 1);
          }
          if (posOrange > -1) {
            this.$scope.map.OrangeFilter.splice(posOrange, 1);
          }
          if (posPink > -1) {
            this.$scope.map.PinkFilter.splice(posPink, 1);
          }
          if (posBlue > -1) {
            this.$scope.map.BlueFilter.splice(posBlue, 1);
          }

          if (posGray > -1) {
            this.$scope.map.BlueFilter.splice(posGray, 1);
          }

        }


        // Yellow 
        if (hess_category === "Non-Vacant Residential Sites" && posYellow === -1) {
          // console.log('it should be yellow');
          this.$scope.map.YellowFilter.push(response.data.parcel_id);

          if (posRed > -1) {
            this.$scope.map.RedFilter.splice(posRed, 1);
          }
          if (posGreen > -1) {
            this.$scope.map.GreenFilter.splice(posGreen, 1);
          }
          if (posOrange > -1) {
            this.$scope.map.OrangeFilter.splice(posOrange, 1);
          }
          if (posPink > -1) {
            this.$scope.map.PinkFilter.splice(posPink, 1);
          }
          if (posBlue > -1) {
            this.$scope.map.BlueFilter.splice(posBlue, 1);
          }

          if (posGray > -1) {
            this.$scope.map.GrayFilter.splice(posGray, 1);
          }

        }

        // Green 
        if (hess_category === "Vacant Non-Residential Sites" && posGreen === -1) {
          // console.log('it should be green');
          this.$scope.map.GreenFilter.push(response.data.parcel_id);

          if (posRed > -1) {
            this.$scope.map.RedFilter.splice(posRed, 1);
          }
          if (posYellow > -1) {
            this.$scope.map.YellowFilter.splice(posYellow, 1);
          }
          if (posOrange > -1) {
            this.$scope.map.OrangeFilter.splice(posOrange, 1);
          }
          if (posPink > -1) {
            this.$scope.map.PinkFilter.splice(posPink, 1);
          }
          if (posBlue > -1) {
            this.$scope.map.BlueFilter.splice(posBlue, 1);
          }
          if (posGray > -1) {
            this.$scope.map.GrayFilter.splice(posGray, 1);
          }
        }

        // Pink 
        if (hess_category === "Public Sites" && posPink === -1) {
          // console.log('it should be pink');
          this.$scope.map.PinkFilter.push(response.data.parcel_id);

          if (posGray > -1) {
            this.$scope.map.GrayFilter.splice(posGray, 1);
          }
          if (posRed > -1) {
            this.$scope.map.RedFilter.splice(posRed, 1);
          }
          if (posYellow > -1) {
            this.$scope.map.YellowFilter.splice(posYellow, 1);
          }
          if (posOrange > -1) {
            this.$scope.map.OrangeFilter.splice(posOrange, 1);
          }
          if (posGreen > -1) {
            this.$scope.map.GreenFilter.splice(posGreen, 1);
          }
          if (posBlue > -1) {
            this.$scope.map.BlueFilter.splice(posBlue, 1);
          }

        }

        // Blue 
        if (hess_category === "Non-Vacant Non-Residential Sites" && posBlue === -1) {
          // console.log('it should be blue');
          this.$scope.map.BlueFilter.push(response.data.parcel_id);

          if (posGray > -1) {
            this.$scope.map.GrayFilter.splice(posGray, 1);
          }
          if (posRed > -1) {
            this.$scope.map.RedFilter.splice(posRed, 1);
          }
          if (posYellow > -1) {
            this.$scope.map.YellowFilter.splice(posYellow, 1);
          }
          if (posOrange > -1) {
            this.$scope.map.OrangeFilter.splice(posOrange, 1);
          }
          if (posGreen > -1) {
            this.$scope.map.GreenFilter.splice(posGreen, 1);
          }
          if (posPink > -1) {
            this.$scope.map.PinkFilter.splice(posPink, 1);
          }

        }

        // Orange 
        if (hess_category === "Vacant Residential Sites" && posOrange === -1) {
          // console.log('it should be orange');
          this.$scope.map.OrangeFilter.push(response.data.parcel_id);

          if (posGray > -1) {
            this.$scope.map.GrayFilter.splice(posGray, 1);
          }
          if (posRed > -1) {
            this.$scope.map.RedFilter.splice(posRed, 1);
          }
          if (posYellow > -1) {
            this.$scope.map.YellowFilter.splice(posYellow, 1);
          }
          if (posBlue > -1) {
            this.$scope.map.BlueFilter.splice(posBlue, 1);
          }
          if (posGreen > -1) {
            this.$scope.map.GreenFilter.splice(posGreen, 1);
          }
          if (posPink > -1) {
            this.$scope.map.PinkFilter.splice(posPink, 1);
          }

        }

        // Unclassified 
        if (hess_category === "Unclassified Sites" && posGray === -1) {
          console.log('it should be unclassified');
          this.$scope.map.GrayFilter.push(response.data.parcel_id);

          if (posRed > -1) {
            this.$scope.map.RedFilter.splice(posRed, 1);
          }
          if (posOrange > -1) {
            this.$scope.map.OrangeFilter.splice(posOrange, 1);
          }
          if (posYellow > -1) {
            this.$scope.map.YellowFilter.splice(posYellow, 1);
          }
          if (posBlue > -1) {
            this.$scope.map.BlueFilter.splice(posBlue, 1);
          }
          if (posGreen > -1) {
            this.$scope.map.GreenFilter.splice(posGreen, 1);
          }
          if (posPink > -1) {
            this.$scope.map.PinkFilter.splice(posPink, 1);
          }
        }

        // Parks/Row Sites 
        if (hess_category === "Parks/ROW Sites") {
          console.log('it should be park row');

          if (posGray > -1) {
            this.$scope.map.GrayFilter.splice(posGray, 1);
          }

          if (posRed > -1) {
            this.$scope.map.RedFilter.splice(posRed, 1);
          }
          if (posOrange > -1) {
            this.$scope.map.OrangeFilter.splice(posOrange, 1);
          }
          if (posYellow > -1) {
            this.$scope.map.YellowFilter.splice(posYellow, 1);
          }
          if (posBlue > -1) {
            this.$scope.map.BlueFilter.splice(posBlue, 1);
          }
          if (posGreen > -1) {
            this.$scope.map.GreenFilter.splice(posGreen, 1);
          }
          if (posPink > -1) {
            this.$scope.map.PinkFilter.splice(posPink, 1);
          }
        }



        //Update map layers to show edit updates
        this.$scope.map.setFilter("GreenLayer", this.$scope.map.GreenFilter);
        this.$scope.map.setFilter("YellowLayer", this.$scope.map.YellowFilter);
        this.$scope.map.setFilter("RedLayer", this.$scope.map.RedFilter);
        this.$scope.map.setFilter("OrangeLayer", this.$scope.map.OrangeFilter);
        this.$scope.map.setFilter("BlueLayer", this.$scope.map.BlueFilter);
        this.$scope.map.setFilter("PinkLayer", this.$scope.map.PinkFilter);
        this.$scope.map.setFilter("GrayLayer", this.$scope.map.GrayFilter);

        // Update basic parcel info box
        this.$scope.feature.address = response.data.address;
        this.$scope.feature.zip_code = response.data.zip_code;
        this.$scope.feature.apn = response.data.apn;

        this.clearSelected();
        $("#siteSelectionModal").modal("hide");
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // End update parcel function

  //Update zoning information when zoning code is selected
  updateZnCodeInfo() {

    this.$scope.zn_codes.forEach(element => {
      if (element.zn_recid === this.$scope.hessParcel.zn_recid) {
        console.log(element);
        this.$scope.hessParcel.zn_code = element.zn_code;
        this.$scope.hessParcel.zn_description = element.zn_description;
        this.$scope.hessParcel.zn_regional_code = element.zn_regional_code;
        this.$scope.hessParcel.zn_regional_description = element.zn_regional_description;
        this.$scope.hessParcel.zn_max_dua = element.zn_max_dua;
        this.$scope.hessParcel.zn_min_dua = element.zn_min_dua;
        this.$scope.hessParcel.zn_max_height = element.zn_max_height;

        this.$scope.hessParcel.zn_units_per_lot = element.zn_units_per_lot;
        this.$scope.hessParcel.zn_max_far = element.zn_max_far;
        this.$scope.hessParcel.zn_min_lot_sqft = element.zn_min_lot_sqft;
        this.$scope.hessParcel.zn_lot_coverage_pct = element.zn_lot_coverage_pct;

        //Calculate max capacity
        if (parseFloat(element.zn_max_dua) && parseFloat(this.$scope.hessParcel.acres)) {
          this.$scope.hessParcel.max_capacity = (parseFloat(element.zn_max_dua) * parseFloat(this.$scope.hessParcel.acres)).toFixed(2);
        } else {
          this.$scope.hessParcel.max_capacity = null;
        }
      }
    });



    // console.log(this.$scope.hessParcel.parcel_id);



  }

  //Update GP information when gp code is selected
  updateGPCodeInfo() {
    this.$scope.gp_codes.forEach(element => {
      console.log(element);
      console.log(this.$scope.hessParcel.gp_recid);
      if (element.gp_recid === this.$scope.hessParcel.gp_recid) {
        this.$scope.hessParcel.gp_description = element.gp_description;
        this.$scope.hessParcel.gp_code = element.gp_code;

      }
    });
  }

  toggleMapLayer(layerName) {
    var visibility;
    this.$scope.loadingDiv = true;
    var type;
    console.log(layerName);
    this.$scope.layerLegend = [];
    var legend;

      // //My list Layer
      if (layerName === "ListLayer") {
        console.log("the visibility: ", visibility);
        if (this.$scope.listToggle) {
          this.$scope.map.setLayoutProperty(layerName, "visibility", "none");
        } else {
          this.$scope.map.setLayoutProperty(layerName, "visibility", "visible");
        }
        this.$scope.loadingDiv = false;
      }

      else {
        for (let index = 0; index < this.$scope.mapLayers.length; index++) {
          const element = this.$scope.mapLayers[index];
    
          if (element.name === layerName) {
            // Check if source already exists in map 
            this.$scope.map.layerName = element.name;

            if (this.$scope.map.getSource(element.source)) {
              console.log('source exists');
    
              visibility = this.$scope.map.getLayoutProperty(
                element.name, "visibility"
              );
              console.log('the visibility', visibility);
              // Toggle layer visibility by changing the layout object's visibility property
              if (visibility === "visible") {
                this.$scope.map.setLayoutProperty(
                  element.name, "visibility", "none"
                );
                this.$scope.visibleLayer = element.name;
                this.className = "";
              } else {
                this.className = "active";
                this.$scope.map.setLayoutProperty(
                  element.name, "visibility", "visible"
                );
              }
              //Add dynamic legend based on circle, numerical or categorical styles
              console.log("Legend: ", element.paint);
              if (element.style === 'circle') {
                legend = element.paint;
                legend['circle-radius'].stops.forEach(circleItem => {
                  this.$scope.layerLegend.push({
                    "type": 'circle',
                    "color": legend['circle-color'],
                    "value": circleItem[0] + " units",
                    "size": circleItem[1] + "px"
                  })
                });
              } else {
               if(element.paint['fill-color'].stops){
                legend = element.paint['fill-color'].stops;
                console.log(element.paint);
                legend.forEach(legend => {
                  if (element.style === 'numerical') {
                    this.$scope.layerLegend.push({
                      "type": 'numerical',
                      "value": legend[0] + "%",
                      "color": legend[1]
                    })
                  } else if (element.style === 'categorical') {
                    this.$scope.layerLegend.push({
                      "type": 'categorical',
                      "value": legend[0],
                      "color": legend[1]
                    })
                  } else if(element.name === 'recapLayer'){

                  } else if(element.name === 'rcaaLayer'){

                  }
    
                });
               }
                console.log(this.$scope.layerLegend);
              }
              // End legend 
    
    
              this.$scope.loadingDiv = false;
            } else {
              //If the source doesn't already exist on the map, add it via the API
              console.log('source doesnt exist');
              console.log(element.url);
    
              //Get data from Socrata/Mapbox and add it to layerData
              this.$http.get(element.url)
                .then((response) => {
                  var layerData = response.data;
                  console.log(layerData);
                  var paint = {};
    
                  //Style mapbox layers
                  if (element.type === 'mapbox') {
                    this.$scope.map.addSource(element.source, {
                      type: layerData.sources.composite.type,
                      url: layerData.sources.composite.url, //Parcel Atlas (updated September 15 2021)
                    });
    
                    // Check if a filter exists on mapbox and/or add it to the layer
                    if (layerData.layers[0].filter) {
                      console.log(layerData.layers[0].filter);
                      this.$scope.map.addLayer({
                        id: element.name,
                        type: layerData.layers[0].type,
                        source: element.source,
                        "source-layer": layerData.layers[0]["source-layer"],
                        paint: layerData.layers[0].paint,
                        filter: layerData.layers[0].filter,
                      },'ListLayer');
                    } else {
                      this.$scope.map.addLayer({
                        id: element.name,
                        type: layerData.layers[0].type,
                        source: element.source,
                        "source-layer": layerData.layers[0]["source-layer"],
                        paint: layerData.layers[0].paint
                      },'ListLayer');
                    }
                  }
    
                  //  Style socrata tract layers 
                  else if (element.type === 'socrata') {
    
                    //Set the paint type based on the style from map.service.js
                    if (element.style === 'circle') {
                      type = 'circle';
                    } else {
                      type = 'fill'
                    }
    
                    //For numerical styles, make sure values are numbers and not strings
                    if (element.style !== 'circle') {
                      console.log(element.property);
                      console.log(layerData);
                      if (element.style === 'numerical') {
                        layerData.forEach(data => {
                          data[element.property] = parseFloat(data[element.property]);
                        });
                      }
    
                      if (element.name === 'raceEthnicityLayer') {
                        //Retrieve Block Geometry Layer
                        this.$http.get('https://data.bayareametro.gov/resource/f86g-vq5u.geojson?$limit=5000000')
                          .then(response => {
                            console.log(response.data);
    
                            var blockGeo = response.data;
    
                            // Numerical or Categorical styles -- Join layerData attributes to tract geometry 
                            if (element.style === 'numerical') {
                              blockGeo.features.forEach(block_element => {
                                var blockId = _.filter(layerData, {
                                  'blkgp_geoid': block_element.properties.geoid
                                })
                                if (blockId[0]) {
                                  block_element.properties[element.property] = parseFloat(blockId[0][element.property]);
                                }
                              });
                            } else if (element.style === 'categorical') {
                              blockGeo.features.forEach(block_element => {
                                var blockId = _.filter(layerData, {
                                  'blkgp_geoid': block_element.properties.geoid
                                })
                                if (blockId[0]) {
                                  block_element.properties[element.property] = blockId[0][element.property];
                                }
                              });
    
    
                            }
    
                            console.log(element.source);
                            console.log(blockGeo)
    
                            //  Add source and layer to the map 
                            this.$scope.map.addSource(element.source, {
                              type: 'geojson',
                              data: blockGeo
                            });
    
                            this.$scope.map.addLayer({
                              id: element.name,
                              type: type,
                              source: element.source,
                              'paint': element.paint
                            },'ListLayer');
    
                            //Add dynamic legend
                            console.log("Legend: ", element.paint);
                            legend = element.paint['fill-color'].stops;
                            console.log(element.paint);
                            legend.forEach(legend => {
                              if (element.style === 'numerical') {
                                this.$scope.layerLegend.push({
                                  "type": 'numerical',
                                  "value": legend[0] + "%",
                                  "color": legend[1]
                                })
                              } else {
                                this.$scope.layerLegend.push({
                                  "type": 'categorical',
                                  "value": legend[0],
                                  "color": legend[1]
                                })
                              }
    
                            });
                            console.log(this.$scope.layerLegend);
    
                            this.$scope.map.setLayoutProperty(element.name, "visibility", "visible");
    
                          })
                      } else if(layerName === 'hcdaffhtcacLayer'){
                        console.log(layerData);
                        this.$scope.map.addSource(element.source, {
                          type: 'geojson',
                          data: layerData
                        });
    
                        this.$scope.map.addLayer({
                          id: element.name,
                          type: type,
                          source: element.source,
                          'paint': element.paint
                        },'ListLayer');
                        this.$scope.map.setLayoutProperty(element.name, "visibility", "visible");
                        console.log(this.$scope.hcdaffhtcacLayerToggle);
    
                        legend = element.paint['fill-color'].stops;
                        console.log(element.paint);
                        legend.forEach(legend => {
                            this.$scope.layerLegend.push({
                              "type": 'categorical',
                              "value": legend[0],
                              "color": legend[1]
                            })
                        })
                        
    
                      } else {
                        // Retrieve Tract Geometry layer 
                        this.$http.get('https://data.bayareametro.gov/resource/j4u9-t2hp.geojson?$limit=20000')
                          .then(response => {
                            console.log(response.data);
    
                            var tractGeo = response.data;
    
                            // Numerical or Categorical styles -- Join layerData attributes to tract geometry 
                            if (element.style === 'numerical') {
                              tractGeo.features.forEach(tract_element => {
                                var tractId = _.filter(layerData, {
                                  'tract_geoid': tract_element.properties.geoid
                                })
                                if (tractId[0]) {
                                  // console.log(tractId[0]);
                                  tract_element.properties[element.property] = parseFloat(tractId[0][element.property]);
                                }
                              });
                            } else if (element.style === 'categorical') {
                              console.log(layerData);
    
                              tractGeo.features.forEach(tract_element => {
                                var tractId = _.filter(layerData, {
                                  'tract_geoid': tract_element.properties.geoid
                                })
                                // console.log(tractId);
                                if (tractId[0]) {
                                  tract_element.properties[element.property] = tractId[0][element.property];
                                }
                              });
    
    
                            } else if(element.style === 'single'){
                              console.log("single");
                                tractGeo.features = _.filter(tractGeo.features,function(geo){
                                  // console.log(geo);
                               var test = _.filter(layerData,{'tract_geoid': geo.properties.geoid});
                               if(test[0]){
                                 return geo;
                               }
                            
                              })
                              // tractGeo.features = features;
                            }
                            console.log(element.name);
                            console.log(element.source);
                            console.log(tractGeo)
    
                            //  Add source and layer to the map 
                            this.$scope.map.addSource(element.source, {
                              type: 'geojson',
                              data: tractGeo
                            });
    
                            this.$scope.map.addLayer({
                              id: element.name,
                              type: type,
                              source: element.source,
                              'paint': element.paint 
                            },'ListLayer');
    
                            //Add dynamic legend
                            console.log("Legend: ", element.paint);
                            if(element.paint['fill-color'].stops){
                              legend = element.paint['fill-color'].stops;
                            console.log(element.paint);
                            legend.forEach(legend => {
                              if (element.style === 'numerical') {
                                if (layerName === "householdIncomeLayer") {
                                  this.$scope.layerLegend.push({
                                    "type": 'numerical',
                                    "value": "$" + legend[0],
                                    "color": legend[1]
                                  })
                                } else {
                                  this.$scope.layerLegend.push({
                                    "type": 'numerical',
                                    "value": legend[0] + "%",
                                    "color": legend[1]
                                  })
                                }
                              } else {
                                this.$scope.layerLegend.push({
                                  "type": 'categorical',
                                  "value": legend[0],
                                  "color": legend[1]
                                })
                              }
    
                            });
                            }
                            console.log(this.$scope.layerLegend);
    
                            this.$scope.map.setLayoutProperty(element.name, "visibility", "visible");
    
                          })
                      }
    
    
                    }
    
                    // Circle/point styles -- Join layer attributes to tract geometry
                    if (element.style === "circle") {
                      console.log(element.property);
                      console.log(layerData);
                      layerData.features.forEach(data => {
                        data.properties[element.property] = parseFloat(data.properties[element.property]);
                      });
    
                      this.$scope.map.addSource(element.source, {
                        type: 'geojson',
                        data: layerData
                      });
                      console.log(element.paint);
    
                      // Add dynamic legend 
                      legend = element.paint;
                      legend['circle-radius'].stops.forEach(circleItem => {
                        this.$scope.layerLegend.push({
                          "type": 'circle',
                          "color": legend['circle-color'],
                          "value": circleItem[0] + " units",
                          "size": circleItem[1] + "px"
                        })
                      });
    
                      this.$scope.map.addLayer({
                        id: element.name,
                        type: type,
                        source: element.source,
                        'paint': element.paint
                      });
                    }
    
                  }
    
                  // Add default opacity to 50% 
                  if (element.name !== 'sphereofinfluenceLayer' && element.type === 'mapbox') {
                    this.$scope.map.setPaintProperty(element.name, "fill-opacity", 0.5);
                  }
    
                  if (element.name === 'sphereofinfluenceLayer') {
                    console.log(element.name);
                    this.$scope.map.setFilter(element.name, [
                      "match",
                      [
                        "get",
                        "jurisdiction"
                      ],
                      [
                        this.$scope.city
                      ],
                      true,
                      false
                    ]);
                  }
    
                  this.$scope.loadingDiv = false;
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          } else {
            if (this.$scope.map.getSource(element.source)) {
              this.$scope.map.setLayoutProperty(element.name, "visibility", "none");
              this.$scope[element.name + "Toggle"] = false;
              this.$scope.loadingDiv = false;
            }
          }
    
          this.$scope.loadingDiv = true;
        }
      }

  

  }

  //Update map using filters
  updateMap() {
    this.$scope.rowCollection = [];

    // Remove any false values from filter
    for (const key in this.$scope.filter) {
      if (this.$scope.filter.hasOwnProperty(key)) {
        if (this.$scope.filter[key] === false) {
          delete this.$scope.filter[key];
        }
      }
    }

    this.$scope.filterLength = Object.keys(this.$scope.filter).length;
    // console.log(this.$scope.filterLength);
    this.$scope.actionsLength = 0;

    this.$http
      .post("/api/data/hess/parcels/filter/all", this.$scope.filter)
      .then((response) => {
        // console.log("filtered records: ", response.data);
        this.$scope.rowCollection = response.data;
        this.$scope.filterParcels = _.map(response.data, "parcel_id");
        var filterKey, arrayKey, layerName;

        this.$scope.hessSummary = {};

        this.$scope.hessCategoryLayers.forEach(element => {
          console.log(element);
          filterKey = "filterParcels" + element.name;
          arrayKey = "array3" + element.name;
          layerName = element.name + 'Layer';


          if (element.name === 'List') {
            this.$scope.filterParcelsList = _.map(
              _.filter(response.data, {
                in_list: true,
              }),
              "parcel_id"
            );
          } else {
            this.$scope[filterKey] = _.map(
              _.filter(response.data, {
                hess_color: element.name,
              }),
              "parcel_id"
            );
          }

          //My Sites

          this.$scope.hessSummary[element.name] = this.$scope[filterKey].length;

          // Set map filters 
          this.$scope[arrayKey] = ["in", "parcel_id"].concat(this.$scope[filterKey]);

          // Update Map Layers with filter 
          this.$scope.map.setFilter(layerName, this.$scope[arrayKey]);

        });

        // Update base parcel layer 
        this.$scope.array3 = ["in", "parcel_id"].concat(this.$scope.filterParcels);
        this.$scope.map.setFilter("parcels", this.$scope.array3);

      })
      .catch((err) => {
        console.log(err);
      });

    // Close filters modal 
    $('#newfiltersModal').modal('hide');
  }

  //Clear filters
  clearFilters() {
    this.$scope.filter = {};
    this.$scope.filterParcels = [];
    this.$scope.filterLength = 0;
    this.$scope.actionsLength = 0;

    //Reset multi selects
    // $("#znRegionalCodeSelect").val('default');
    // $("#znRegionalCodeSelect").selectpicker("refresh");

    // $("#znCodeSelect").val('default');
    // $("#znCodeSelect").selectpicker("refresh");

    this.$scope.rowCollection = [];

    // Set the filter to populate features into the layer.
    this.$scope.map.setFilter("parcels", ["in", "jurisdiction", this.$scope.city]);
    this.$scope.map.setFilter("ListLayer", this.$scope.map.ListFilter);
    // this.$scope.map.setFilter('zoomParcelLayer', ["in", "parcel_id", ""]);
    if (this.$scope.map.getSource("zoomParcelSource")) {
      this.$scope.map.removeLayer("zoomParcelLayer");
      this.$scope.map.removeSource("zoomParcelSource");
    }

    // Reset hess layer filters 
    this.$scope.array3List = this.$scope.map.ListFilter;

  }

  /**
   * @desc Opens appropriate update modal window based on parameters
   * @param {object} data - data loaded from value selected in the table
   * @param (string) crudType - type of update operation to perform (values: create, edit or delete)
   */
  openSiteEditModal(parcel_id) {
    this.$scope.parcel_id = parcel_id;
    //Open CRUD Modal
    if (parcel_id) {
      $("#siteSelectionModal").modal();

      this.dbFactory.getTractDetail(parcel_id) //DB Factory function
        .then((response) => {
          var hess_category_desc;
         

          Object.entries(response.data[0]).forEach(([key, value]) => {
            console.log(parseInt(value).isNaN)
            if (key === 'racially_concentrated_aff_flg') {
              if (value === '1' || value === '1.0') {
                this.$scope.hessTract.rcaa = true;
              } else {
                this.$scope.hessTract.rcaa = false;
              }
            } else if (key === 'racially_concentrated_pov_flg') {
              if (value === '1' || value === '1.0') {
                this.$scope.hessTract.recap = true;
              } else {
                this.$scope.hessTract.recap = false;
              }
            } else if (!Number.isNaN(parseInt(value))) {
              value = parseInt(value) + "%";
            }
            this.$scope.hessTract[key] = value;
            console.log(key, value); // key ,value
          });

        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  /**
   * @desc Opens appropriate update modal window based on parameters after clicking on More Info button in map popup
   * @param {object} parcel_id - ID of the parcel clicked on
   * @param (string) dbFactory - Database data factory
   * @param (string) $scope - Application level global scope
   */
  openSiteEditModalMoreInfo(parcel_id, $http, $scope, dbFactory) {
    //Open CRUD Modal
    if (parcel_id) {
      $("#siteSelectionModal").modal();

      dbFactory.getParcelDetail(parcel_id) //DB Factory function
        .then((response) => {
          var hess_category_desc;
          // console.log(response.data[0]);
          $scope.hessParcel = response.data[0];
          var znCode = _.filter($scope.zn_codes, {
            zn_recid: response.data[0].zn_recid,
          });
          // console.log("znCode: ", znCode);

          //Populate zoning fields of modal window
          if (znCode[0].zn_code) {
            $scope.hessParcel.zn_code = znCode[0].zn_code;
          }
          $scope.hessParcel.zn_description = znCode[0].zn_description;
          $scope.hessParcel.zn_max_height = znCode[0].zn_max_height;
          $scope.hessParcel.zn_min_dua = znCode[0].zn_min_dua;

          hess_category_desc = _.filter($scope.hessCategoryLayers, {
            name: $scope.hessParcel.hess_color
          });
          // console.log('hess category desc: ', hess_category_desc);

        })
        .catch((err) => {
          console.log(err);
        });
    }
  }


  //Open filters modal
  openFiltersModal() {
    //Refresh multi select inputs in case data hasn't yet loaded
    // setTimeout(function () {
    //   $('.selectpicker').selectpicker('refresh'); // refresh the selectpicker with fetched courses
    // }, 1000);
    $('#newfiltersModal').modal();
  }


  /**
   * @desc Opens appropriate update modal window based on parameters
   * @param {object} data - data loaded from value selected in the table
   * @param (string) crudType - type of update operation to perform (values: create, edit or delete)
   */
  zoomToSite(parcelId) {
    //Open CRUD Modal
    this.$scope.zoomSpinner = true;
    this.$http
      .get("/api/data/hess/parcelgeo/" + parcelId)
      .then((response) => {
        if (this.$scope.map.getSource("zoomParcelSource")) {
          this.$scope.map.removeLayer("zoomParcelLayer");
          this.$scope.map.removeSource("zoomParcelSource");
        }
        this.$scope.map.addSource("zoomParcelSource", {
          type: "geojson",
          data: {
            type: "Feature",
            geometry: response.data[0].geometry,
          },
        });
        this.$scope.map.addLayer({
          id: "zoomParcelLayer",
          type: "fill",
          source: "zoomParcelSource",
          layout: {},
          paint: {
            "fill-outline-color": "#00fffa",
            "fill-color": "white",
            "fill-opacity": 0.5,
          },
        });

        var bbox = turf.extent(response.data[0].geometry);
        this.$scope.map.fitBounds(bbox, {
          padding: -50,
        });
        this.$scope.zoomSpinner = false;
      })
      .catch((err) => {
        console.log(err);
      });
    // Resize map after modal div is fully rendered
  }

  /**
   * @desc Opens appropriate update modal window based on parameters
   * @param {object} data - data loaded from value selected in the table
   * @param (string) crudType - type of update operation to perform (values: create, edit or delete)
   */
  zoomToSiteFromParams(parcelId, $scope, $http, $location) {
    //Open CRUD Modal
    //    $scope.zoomSpinner = true;
    if (parcelId) {
      $http
        .get("/api/data/hess/parcelgeo/" + parcelId)
        .then((response) => {
          if ($scope.map.getSource("zoomParcelSource")) {
            $scope.map.removeLayer("zoomParcelLayer");
            $scope.map.removeSource("zoomParcelSource");
          }
          $scope.map.addSource("zoomParcelSource", {
            type: "geojson",
            data: {
              type: "Feature",
              geometry: response.data[0].geometry,
            },
          });
          $scope.map.addLayer({
            id: "zoomParcelLayer",
            type: "fill",
            source: "zoomParcelSource",
            layout: {},
            paint: {
              "fill-color": "#00fffa",
              "fill-opacity": 0.8,
            },
          });

          var bbox = turf.extent(response.data[0].geometry);
          $scope.map.fitBounds(bbox, {
            padding: -50,
          });
          $scope.zoomSpinner = false;
        })
        .catch((err) => {
          console.log(err);
        });
      // Resize map after modal div is fully rendered
      $location.search({});
    }
  }

  changeView(type) {
    if (type === "filters") {
      this.$scope.isResults = true;
      this.$scope.isFilters = false;
    } else if (type === "results") {
      this.$scope.isFilters = true;
      this.$scope.isResults = false;
    }
  }

  getMyList() {
    console.log('running get my list');
    this.$scope.listRecords = [];
    this.$http.get('/api/data/hess/parcel/list/' + this.$scope.city)
      .then(response => {
        // console.log(response.data);
        this.$scope.myListParcels = response.data;
        if (this.$scope.myListParcels.length > 0) {
          this.$scope.myListParcels.forEach(element => {
            this.$scope.listRecords.push(element.parcel_id);
          });
        }
        this.$scope.rowListCollection = response.data;

      })
      .catch(err => {
        console.log(err);
      });
  }

  closeSiteSelectionModal() {
    $("#siteSelectionModal").modal("hide");
  }

  closeFilterModal() {
    $("#newfiltersModal").modal("hide");
  }
  // Admin 
  updateJurisdiction() {
    this.loadMap(this.$scope.city)
    this.$scope.displacementRiskSummary = {};
    this.$scope.hcdSummary = {};
    this.$scope.pocSummary = {};
    this.$scope.rcaaSummary = {};
    this.$scope.recapSummary = {};
    this.getDisplacementRiskSummaries();
    this.getHCDSummaries();
    this.getPOCSummaries();
    this.getRCAASummaries();
    this.getRECAPSummaries();
  }

  getJurisdictions() {
    this.$http.get('/api/data/admin/lookup/jurisdictions')
      .then(response => {
        if (this.$scope.user.role === 'consultant') {
          var jurisdictions = response.data[0].jurisdiction.split(',');
          var jurisdictionsArray = [];
          jurisdictions.forEach(element => {
            jurisdictionsArray.push({
              'jurisdiction': element
            });
          });
          this.$scope.jurisdictions = jurisdictionsArray;
        } else if (this.$scope.user.role === 'admin') {
          this.$scope.jurisdictions = response.data;
        }
        // console.log(this.$scope.jurisdictions);
      })
      .catch(err => {
        console.log(err);
      })
  }

  //  Parcel Notes 
  addParcelNote() {
    var recid = uuid.v1();
    var data = {
      recid: recid,
      note: this.$scope.parcel_note,
      parcel_id: this.$scope.parcel_id
    };
    console.log(data);

    this.$http
      .post("/api/data/hess/parcel/note/add", data)
      .then((response) => {
        this.$scope.parcel_note = "";
        this.$scope.parcelNotes.unshift(response.data);
      })
      .catch((err) => {
        console.log(err);

      });
  }

  getParcelNotes() {
    this.$http
      .get("/api/data/hess/notes/" + this.$scope.parcel_id)
      .then((response) => {
        this.$scope.parcelNotes = response.data;

      })
      .catch((err) => {
        console.log(err);

      });
  }

  //Summaries 

  //Displacement Risk
  getDisplacementRiskSummaries() {
    //  Get my list summary 
    this.$http.get('/api/data/affh/summary/disprisk/' + this.$scope.city + '/list')
      .then(response => {
        this.$scope.totalSitesJurisdiction = (_.filter(this.$scope.parcelCounts, {
          "jurisdiction": this.$scope.city
        }))[0].count_parcel_id;
        this.$scope.displacementRiskCategories.forEach(element => {
          if (_.filter(response.data, {
              "displacement_risk": element.displacement_risk
            }).length > 0) {
            this.$scope.displacementRiskSummary["List-" + element.displacement_risk] = 100 * (parseInt((_.filter(response.data, {
              "displacement_risk": element.displacement_risk
            }))[0].count_displacement_risk) / parseInt(this.$scope.totalSitesJurisdiction));
          } else {
            this.$scope.displacementRiskSummary["List-" + element.displacement_risk] = 0;
          }
        });

        this.$scope.displacementRiskSummary['List-Displacement'] = this.$scope.displacementRiskSummary["List-Low-Income/Susceptible to Displacement"] + this.$scope.displacementRiskSummary["List-Ongoing Displacement"];
        this.$scope.displacementRiskSummary['List-Exclusion'] = this.$scope.displacementRiskSummary["List-At Risk of Becoming Exclusive"] + this.$scope.displacementRiskSummary["List-Becoming Exclusive"] + this.$scope.displacementRiskSummary["List-Stable/Advanced Exclusive"];
        this.$scope.displacementRiskSummary['List-Gentrification'] = this.$scope.displacementRiskSummary["List-Advanced Gentrification"] + this.$scope.displacementRiskSummary["List-At Risk of Gentrification"] + this.$scope.displacementRiskSummary["List-Early/Ongoing Gentrification"];
        this.$scope.displacementRiskSummary['List-Income'] = this.$scope.displacementRiskSummary["List-Stable Moderate/Mixed Income"];
        console.log(this.$scope.displacementRiskSummary);

      })
      .catch(err => {
        console.log(err);
      })

    // Get total sites summery 
    this.$http.get('/api/data/affh/summary/disprisk/' + this.$scope.city + '/total')
      .then(response => {
        console.log(response.data);
        this.$scope.totalSitesJurisdiction = (_.filter(this.$scope.parcelCounts, {
          "jurisdiction": this.$scope.city
        }))[0].count_parcel_id;

        this.$scope.displacementRiskCategories.forEach(element => {
          if (_.filter(response.data, {
              "displacement_risk": element.displacement_risk
            }).length > 0) {
            this.$scope.displacementRiskSummary["Total-" + element.displacement_risk] = 100 * (parseInt((_.filter(response.data, {
              "displacement_risk": element.displacement_risk
            }))[0].count_displacement_risk) / parseInt(this.$scope.totalSitesJurisdiction));
          } else {
            this.$scope.displacementRiskSummary["Total-" + element.displacement_risk] = 0;
          }
        });

        this.$scope.displacementRiskSummary['Total-Displacement'] = this.$scope.displacementRiskSummary["Total-Low-Income/Susceptible to Displacement"] + this.$scope.displacementRiskSummary["Total-Ongoing Displacement"];
        this.$scope.displacementRiskSummary['Total-Exclusion'] = this.$scope.displacementRiskSummary["Total-At Risk of Becoming Exclusive"] + this.$scope.displacementRiskSummary["Total-Becoming Exclusive"] + this.$scope.displacementRiskSummary["Total-Stable/Advanced Exclusive"];
        this.$scope.displacementRiskSummary['Total-Gentrification'] = this.$scope.displacementRiskSummary["Total-Advanced Gentrification"] + this.$scope.displacementRiskSummary["Total-At Risk of Gentrification"] + this.$scope.displacementRiskSummary["Total-Early/Ongoing Gentrification"];
        this.$scope.displacementRiskSummary['Total-Income'] = this.$scope.displacementRiskSummary["Total-Stable Moderate/Mixed Income"];

        console.log(this.$scope.displacementRiskSummary);


      })
      .catch(err => {
        console.log(err);
      })
  }

  getHCDSummaries() {
    //  Get my list summary 
    this.$http.get('/api/data/affh/summary/hcd/' + this.$scope.city + '/list')
      .then(response => {
        this.$scope.totalSitesJurisdiction = (_.filter(this.$scope.parcelCounts, {
          "jurisdiction": this.$scope.city
        }))[0].count_parcel_id;
        this.$scope.hcdCategories.forEach(element => {
          if (_.filter(response.data, {
              "hcd_tcac_resource_level_ua": element.hcd_tcac_resource_level_ua
            }).length > 0) {
            this.$scope.hcdSummary["List-" + element.hcd_tcac_resource_level_ua] = 100 * (parseInt((_.filter(response.data, {
              "hcd_tcac_resource_level_ua": element.hcd_tcac_resource_level_ua
            }))[0].count_hcd_tcac_resource_level_ua) / parseInt(this.$scope.totalSitesJurisdiction));
          } else {
            this.$scope.hcdSummary["List-" + element.hcd_tcac_resource_level_ua] = 0;
          }
        });


        console.log(this.$scope.hcdSummary);

      })
      .catch(err => {
        console.log(err);
      })

    // Get total sites summery 
    this.$http.get('/api/data/affh/summary/hcd/' + this.$scope.city + '/total')
      .then(response => {
        this.$scope.totalSitesJurisdiction = (_.filter(this.$scope.parcelCounts, {
          "jurisdiction": this.$scope.city
        }))[0].count_parcel_id;

        this.$scope.hcdCategories.forEach(element => {
          if (_.filter(response.data, {
              "hcd_tcac_resource_level_ua": element.hcd_tcac_resource_level_ua
            }).length > 0) {
            this.$scope.hcdSummary["Total-" + element.hcd_tcac_resource_level_ua] = 100 * (parseInt((_.filter(response.data, {
              "hcd_tcac_resource_level_ua": element.hcd_tcac_resource_level_ua
            }))[0].count_hcd_tcac_resource_level_ua) / parseInt(this.$scope.totalSitesJurisdiction));
          } else {
            this.$scope.hcdSummary["Total-" + element.hcd_tcac_resource_level_ua] = 0;
          }
        });



        console.log(this.$scope.hcdSummary);


      })
      .catch(err => {
        console.log(err);
      })
  }

  getPOCSummaries() {
    //  Get my list summary 
    this.$http.get('/api/data/affh/summary/poc/' + this.$scope.city + '/list')
      .then(response => {
        this.$scope.totalSitesJurisdiction = (_.filter(this.$scope.parcelCounts, {
          "jurisdiction": this.$scope.city
        }))[0].count_parcel_id;
        this.$scope.pocSummary["List-POC"] = 100 * (parseInt(response.data[0].count_parcel_id) / this.$scope.totalSitesJurisdiction);
        console.log(response.data);

      })
      .catch(err => {
        console.log(err);
      })

    // Get total sites summery 
    this.$http.get('/api/data/affh/summary/poc/' + this.$scope.city + '/total')
      .then(response => {
        this.$scope.totalSitesJurisdiction = (_.filter(this.$scope.parcelCounts, {
          "jurisdiction": this.$scope.city
        }))[0].count_parcel_id;
        this.$scope.pocSummary["Total-POC"] = 100 * (parseInt(response.data[0].count_parcel_id) / this.$scope.totalSitesJurisdiction);

        console.log(response.data);


      })
      .catch(err => {
        console.log(err);
      })
  }

  getRCAASummaries() {
    //  Get my list summary 
    this.$http.get('/api/data/affh/summary/rcaa/' + this.$scope.city + '/list')
      .then(response => {
        this.$scope.totalSitesJurisdiction = (_.filter(this.$scope.parcelCounts, {
          "jurisdiction": this.$scope.city
        }))[0].count_parcel_id;
        this.$scope.rcaaSummary["List-RCAA"] = 100 * (parseInt(response.data[0].count_parcel_id) / this.$scope.totalSitesJurisdiction);
        console.log(response.data);

      })
      .catch(err => {
        console.log(err);
      })

    // Get total sites summery 
    this.$http.get('/api/data/affh/summary/rcaa/' + this.$scope.city + '/total')
      .then(response => {
        this.$scope.totalSitesJurisdiction = (_.filter(this.$scope.parcelCounts, {
          "jurisdiction": this.$scope.city
        }))[0].count_parcel_id;
        this.$scope.rcaaSummary["Total-RCAA"] = 100 * (parseInt(response.data[0].count_parcel_id) / this.$scope.totalSitesJurisdiction);

        console.log(response.data);


      })
      .catch(err => {
        console.log(err);
      })
  }

  getRECAPSummaries() {
    //  Get my list summary 
    this.$http.get('/api/data/affh/summary/recap/' + this.$scope.city + '/list')
      .then(response => {
        this.$scope.totalSitesJurisdiction = (_.filter(this.$scope.parcelCounts, {
          "jurisdiction": this.$scope.city
        }))[0].count_parcel_id;
        this.$scope.recapSummary["List-RECAP"] = 100 * (parseInt(response.data[0].count_parcel_id) / this.$scope.totalSitesJurisdiction);
        console.log(response.data);

      })
      .catch(err => {
        console.log(err);
      })

    // Get total sites summery 
    this.$http.get('/api/data/affh/summary/recap/' + this.$scope.city + '/total')
      .then(response => {
        this.$scope.totalSitesJurisdiction = (_.filter(this.$scope.parcelCounts, {
          "jurisdiction": this.$scope.city
        }))[0].count_parcel_id;
        this.$scope.recapSummary["Total-RECAP"] = 100 * (parseInt(response.data[0].count_parcel_id) / this.$scope.totalSitesJurisdiction);

        console.log(response.data);


      })
      .catch(err => {
        console.log(err);
      })
  }
}

export default angular.module('hessApplicationApp.affh', [uiRouter])
  .config(routes)
  .component('affh', {
    template: require('./affh.html'),
    controller: AffhComponent,
    controllerAs: 'affhCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/affh/affh.component.js